import { ElementType } from "@easy-email-pro-core/constants";
import { Show } from "./Show";
import { ForEach } from "./ForEach";

export default {
  [ElementType.FOR_EACH]: ForEach,
  [ElementType.SHOW]: Show,
};
